import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const useCheckLogin = () => {
  const userData = useSelector((state) => state?.userAuth?.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userData) {
      navigate("/login", { state: { fromGuest: true } });
    } else if (userData?.user_type === "Guest") {
      navigate("/search-store");
    }
  }, [userData, navigate]);
};